import React, { useState, useEffect } from "react";
import { useAllFilterBaseContext } from "../../../../../Context/AllFilterBaseContext";

const PriceFilter = ({ filter, setfilter }) => {
  const { state, setMinHourlyRate, setMaxHourlyRate } =
    useAllFilterBaseContext();
  const { minHourlyRate, maxHourlyRate } = state;
  const [tempMinRate, setTempMinRate] = useState(minHourlyRate || "");
  const [tempMaxRate, setTempMaxRate] = useState(maxHourlyRate || "");
  const [error, setError] = useState("");

  useEffect(() => {
    setTempMinRate(minHourlyRate !== undefined ? minHourlyRate : "");
  }, [minHourlyRate]);

  useEffect(() => {
    setTempMaxRate(maxHourlyRate !== undefined ? maxHourlyRate : "");
  }, [maxHourlyRate]);

  const handleApply = async () => {
    const minRate = parseFloat(tempMinRate);
    const maxRate = parseFloat(tempMaxRate);

    if (isNaN(minRate) || isNaN(maxRate)) {
      setError("Please enter valid numbers.");
      return;
    }

    if (minRate < 0 || maxRate < 0) {
      setError("Rates cannot be negative.");
      return;
    }

    if (minRate <= 0) {
      setError("Min price cannot be zero or negative.");
      return;
    }

    if (maxRate <= 0) {
      setError("Max price cannot be zero.");
      return;
    }

    if (minRate > maxRate) {
      setError("Min rate cannot be greater than max rate.");
      return;
    }

    if (setfilter) {
      setfilter(false)
    }

    await new Promise((resolve) => {
      setMinHourlyRate(minRate);
      setMaxHourlyRate(maxRate);
      resolve();
    });

    setError("");
  };

  return (
    <div className="filter-cont" key={filter.id}>
      <h6>{filter.title}</h6>
      <div className="hourly-rate">
        <input
          type="number"
          min="0"
          className="form-control"
          placeholder="Min"
          value={tempMinRate}
          onChange={(e) => setTempMinRate(e.target.value)}
        />
        <input
          min="1"
          type="number"
          className="form-control"
          placeholder="Max"
          value={tempMaxRate}
          onChange={(e) => setTempMaxRate(e.target.value)}
        />
      </div>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <button
        className="buttons background-button mt-3 w-100"
        onClick={handleApply}
      >
        Apply
      </button>
    </div>
  );
};

export default PriceFilter;
